import styled from 'styled-components'
import { applyProps, PropTypesStyledHTML } from '../../../../utils/styled_helpers'
import React from 'react'

interface BoxProps extends PropTypesStyledHTML {
  pos?: string;
  opacity?: string;
  w?: string | number;
}

export const BoxStyled = styled.div<BoxProps>`
  ${(props) => applyProps(props)}
  ${({ w }) => {
    if (w) {
      return `
        @media (max-width: 992px) {
          width: 100%;
        }
      `
    }
    return ''
  }}
`

export const Box: React.FC<BoxProps> = (props) => (
  <BoxStyled {...props}>
    {props.children}
  </BoxStyled>
)
